import { GridCellProps } from '@progress/kendo-react-grid';
import { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import GridCellBase from '../GridCellBase';

const PoItemsCompletedCell = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { onLineItemSummariesClick } = cellClick?.(null);
  const { dataItem } = props;
  const { poItemsCompleted } = dataItem;

  return (
    <GridCellBase
      {...props}
      title={poItemsCompleted}
      rowSelectionEnabled={true}
      style={{
        backgroundColor: poItemsCompleted === 'Y' ? '#C3D7B9' : '#EFB2B2',
        textAlign: 'center',
      }}
    >
      <span>
        {poItemsCompleted}
        {poItemsCompleted === 'N' && (
          <span
            title={'View Details'}
            className="k-icon k-i-info cursor-pointer"
            onClick={() => onLineItemSummariesClick(dataItem)}
          />
        )}
      </span>
    </GridCellBase>
  );
};

export default PoItemsCompletedCell;
